"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lusolveDependencies = void 0;

var _dependenciesDenseMatrixClassGenerated = require("./dependenciesDenseMatrixClass.generated.js");

var _dependenciesLsolveGenerated = require("./dependenciesLsolve.generated.js");

var _dependenciesLupGenerated = require("./dependenciesLup.generated.js");

var _dependenciesMatrixGenerated = require("./dependenciesMatrix.generated.js");

var _dependenciesSluGenerated = require("./dependenciesSlu.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _dependenciesUsolveGenerated = require("./dependenciesUsolve.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var lusolveDependencies = {
  DenseMatrixDependencies: _dependenciesDenseMatrixClassGenerated.DenseMatrixDependencies,
  lsolveDependencies: _dependenciesLsolveGenerated.lsolveDependencies,
  lupDependencies: _dependenciesLupGenerated.lupDependencies,
  matrixDependencies: _dependenciesMatrixGenerated.matrixDependencies,
  sluDependencies: _dependenciesSluGenerated.sluDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  usolveDependencies: _dependenciesUsolveGenerated.usolveDependencies,
  createLusolve: _factoriesAny.createLusolve
};
exports.lusolveDependencies = lusolveDependencies;